import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import { layouts } from '@/utils/preset'
import { desktop, laptop, tablet, tabletL, tabletS, mobile } from '@/utils/media'
import { mq, rem } from '@/utils/helpers'
import PageBase from '@/components/common/Page'
import ThemeConsumer from '@/hoc/ThemeConsumer'
import SEO from '@/components/head/seo'
import LD from '@/components/head/linking-data'
import LDEntity from '@/utils/linking-data'
import CVButton from '@/components/app/CVButton'
import Header from '@/components/app/Header'
import MV from '@/components/app/MV'
import Reason from '@/components/modules/Reason/Section'
import Compare from '@/components/modules/Compare/Section'
import Works from '@/components/modules/Works/Section'
import Case from '@/components/modules/Case/Section'
import Subsidy from '@/components/modules/Subsidy/Section'
import Plans from '@/components/modules/Plans/Section'
import Options from '@/components/modules/Options/Section'
import Conversion from '@/components/modules/Conversion/Section'
import MainForm from '@/components/modules/Contact/MainForm'
import Footer from '@/components/app/Footer'

class IndexPage extends React.Component {
  render () {
    return (
      <StaticQuery
        query={query}
        render={data => {
          const siteMeta = data.site.siteMetadata
          return (
            <Root theme={this.props.theme} id="root">
              <SEO ogType="website" location={this.props.location}/>
              <LD json={LDEntity.WebSite(siteMeta)}/>
              <CVButton to="/#form" color="accent.three">無料相談してみる</CVButton>
              <Left id="left">
                <Header />
                <MV />
                <Main>
                  <Section id="reason" css={styles.Reason}><Reason /></Section>
                  <Section id="compare"><Compare /></Section>
                  <Section id="works"><Works /></Section>
                  <Section id="case"><Case /></Section>
                  <Section id="subsidy"><Subsidy /></Section>
                  <Section id="plans"><Plans /></Section>
                  <Section id="options"><Options /></Section>
                  <Section id="cv"><Conversion /></Section>
                </Main>
                <Foot css={styles.Foot1}>
                  <Footer />
                </Foot>
              </Left>
              <Right theme={this.props.theme}>
                <MainForm id="form" />
              </Right>
              <Foot css={styles.Foot2}>
                <Footer />
              </Foot>
            </Root>
          )
        }}
      />
    )
  }
}

const Root = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: ${props => props.theme.background.dark};
  @media ${mq.and(desktop, laptop, tabletL)} {
    max-width: ${rem(layouts.defs.maxWidth)};
    margin: 0 auto;
    display: flex;
  }
  @media ${mq.and(tabletS, mobile)} {
    display: block;
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
  }
`

const Left = styled.div`
  @media ${mq.and(desktop, laptop, tabletL)} {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
  }
`

const Right = styled.div`
  background-color: ${props => props.theme.gray.c};
  @media ${mq.and(desktop, laptop, tabletL)} {
    width: ${rem(460)};
    flex-grow: 0;
    flex-shrink: 0;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    min-height: 100vh;
  }
`

const Main = styled.div``

const Section = styled.div``

const Foot = styled.div`
  position: relative;
`

const styles = {
  Reason: css`
    margin-top: 0;
    @media ${mq.and(tablet)} {
      margin-top: 0;
    }
    @media ${mq.and(mobile)} {
      margin-top: 0;
    }
  `,
  Foot1: css`
  @media ${mq.and(tabletS, mobile)} {
      display: none;
    }
  `,
  Foot2: css`
    @media ${mq.and(desktop, laptop, tabletL)} {
      display: none;
    }
  `
}

export default PageBase(ThemeConsumer(IndexPage))

const query = graphql`
  query IndexPageQuery {
    site {
      siteMetadata {
        siteUrl
        title
        description
        image
        company {
          name
          logo
          siteUrl
        }
      }
    }
  }
`
